<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Abend</h3>
<p class="vers">Purpurschimmer tränket<br class="calibre2"/>
die Rebenhügel.<br class="calibre2"/>
Tiefer und tiefer senket<br class="calibre2"/>
ihre dunklen Flügel<br class="calibre2"/>
die Nacht.<br class="calibre2"/>
Lautlos fallen<br class="calibre2"/>
Schleier herab auf Schleier.<br class="calibre2"/>
Wolkenpilger wallen<br class="calibre2"/>
ferne zur Sonnenscheidefeier.<br class="calibre2"/>
Sacht<br class="calibre2"/>
wecket ein Hauch in der Bäume<br class="calibre2"/>
lautlosen Wipfeln die Träume.<br class="calibre2"/>
Eh wir's gedacht,<br class="calibre2"/>
hat sie mit bleichem Munde<br class="calibre2"/>
getrunken das Gold der Abendstunde:<br class="calibre2"/>
die alte Nacht.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0009.vue?035d6d88